export const logos = {
  wert: "Wert",
  simplex: "Simplex",
  nowpayments: "NowPayments",
};
